import { Attachment } from '../../../shared/components/attachments/attachment-service/models/attachment-model';
import { Answer } from '../../applicant-service/service-models/Answer';
import { Choice } from './Choice';

export class Question {
  id: number;
  answers: Array<Answer>;
  choices: Array<Choice>;
  attachments: Array<Attachment>;
  order: number;
  identifier: string;
  title: string;
  type: string;
  version: number;
  file: File;
  isRequired: boolean;
}
